import * as React from 'react';
import { useTheme } from '../../theme';
import cn from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import Slide from '@mui/material/Slide';
import { IconButton } from '@mui/material';
import { CdnIcon } from '@shared/ui';

export interface Props {
	isOpen: boolean;
	onClose: () => void;
	noPadding?: boolean;
	scrollable?: boolean;
	className?: string;
	overlayClassName?: string;
	header?: string;
	headerClassName?: string;
	wrapperClassName?: string;
}

export const SlideBottom: React.FunctionComponent<Props> = props => {
	const theme = useTheme('SlideBottom').SlideBottomStyles,
		[isVisible, setVisibile] = useState(false);

	const onClick = useCallback(() => {
		props.onClose();
		window.document.body.style.overflow = 'auto';
	}, [props.onClose]);

	useEffect(() => {
		const bodyComponent = window.document.body;

		if (props.isOpen) {
			setVisibile(true);
			bodyComponent.style.overflow = 'hidden';
		} else {
			if (isVisible) {
				bodyComponent.style.overflow = 'auto';

				setTimeout(() => {
					setVisibile(false);
				}, 250);
			}
		}

		return () => {
			window.document.body.style.overflow = 'auto';
		};
	}, [props.isOpen]);

	return (
		isVisible && (
			<div
				className={cn(theme.mainWrapper, props.wrapperClassName, {
					[theme.wrapper_closed]: !props.isOpen
				})}
			>
				<div className={cn(theme.wrapper, props.overlayClassName)} onClick={onClick} />

				<Slide direction="up" in={props.isOpen}>
					<div
						className={cn(theme.container, props.className, {
							[theme.container_noPadding]: props.noPadding,
							[theme.container_scrollable]: props.scrollable
						})}
					>
						{props.header && (
							<div className={cn(theme.header, props.headerClassName)}>
								<span className={theme.modal_title}>{props.header}</span>
								<IconButton className={theme.close} onClick={props.onClose}>
									<CdnIcon icon={'Action/Close-Clear'} />
								</IconButton>
							</div>
						)}

						{props.children}
					</div>
				</Slide>
			</div>
		)
	);
};

export default SlideBottom;
